import { useState } from "react";

export const useSteps = ({ initialStep, maxStep }) => {
  const [currentStep, setCurrentStep] = useState(initialStep ?? 0);

  const setStep = (step) => {
    setCurrentStep(step);
  };

  const goToNextStep = () => {
    setCurrentStep((prev) => (prev += 1));
  };

  const goToPrevStep = () => {
    setCurrentStep((prev) => (prev -= 1));
  };

  const skip = () => {
    setCurrentStep(maxStep);
  };

  const reset = () => {
    setCurrentStep(0);
  };

  return {
    goToNextStep,
    goToPrevStep,
    setStep,
    reset,
    skip,
    currentStep,
  };
};
